//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import customer from '@/customer'

export default {
  name: 'selectStore',
  data () {
    return {
      storeList: [],
      currentStoreId: 0,
      selecting: false,
    }
  },
  created(){
    if(!customer.enableRegionManager){
      this.$router.replace({path:'/home'});
      return;
    }
    this.currentStoreId = Number(this.$func.getLocal('cid')) || 0;
    this.loadStoreList();
  },
  methods:{
    loadStoreList(){
      var cache = this.$func.getLocal('store_list');
      if(cache){
        try{
          var list = JSON.parse(cache);
          this.storeList = Array.isArray(list) ? list : [];
        }catch(e){
          this.storeList = [];
        }
      }
      if(!this.storeList.length && this.currentStoreId > 0){
        this.$api.getInfo({}).then((res)=>{
          if(res && Array.isArray(res.data.store_list)){
            this.storeList = res.data.store_list;
            this.$func.setLocal('store_list', JSON.stringify(this.storeList));
          }
        });
      }
    },
    formatAddress(item){
      return [item.province, item.city, item.district, item.address].filter(function(value){
        return value;
      }).join('');
    },
    selectStore(item){
      if(this.selecting){
        return false;
      }
      var cid = Number(item.id);
      if(!cid){
        this.$func.showToast('门店数据错误');
        return false;
      }
      this.selecting = true;
      this.$api.selectCommunityStore({cid:cid}).then((res)=>{
        this.selecting = false;
        if(res){
          this.currentStoreId = cid;
          this.$func.setLocal('cid', cid);
          this.$func.setLocal('current_store_name', item.name || '');
          this.$func.setLocal('node_v1','');
          this.getAccess();
        }
      }).catch(()=>{
        this.selecting = false;
      });
    },
    getAccess(){
      this.$api.getAccess({}).then((res)=>{
        if(res.data){
          this.$func.setLocal('node_v1',JSON.stringify(res.data));
          if(this.$route.query.from === 'user'){
            this.$router.replace({path:'/user'});
            return;
          }
          let grade = parseInt(this.$func.getLocal('grade'));
          if([3,4,5,8,13].includes(grade)){
            this.$router.replace({path:'/home'});
          }else if([10,11].includes(grade)){
            this.$router.replace({path:'/factory'});
          }else if(grade === 7){
            this.$router.replace({path:'/driver'});
          }else{
            this.$router.replace({path:'/user'});
          }
        }
      })
    },
    backLogin(){
      this.$func.setLocal('cid','');
      this.$func.setLocal('store_list','');
      this.$router.replace({path:'/login'});
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/selectStore.vue